import { ConstantContent } from '@sensenet/client-core';
import { useEffect, useState } from 'react';
import { useRepository } from "./use-repository.js";
/*
 * The type of a specific package
 */
export let PackageType;

/**
 * Represents a .NET Assembly in the Version Info
 */
(function (PackageType) {
  PackageType[PackageType["Tool"] = 0] = "Tool";
  PackageType[PackageType["Patch"] = 1] = "Patch";
  PackageType[PackageType["Install"] = 2] = "Install";
})(PackageType || (PackageType = {}));
/**
 * Represents a sensenet Component in the Version Info
 */
/**
 * Represents a sensenet Package in the Version Info
 */
/**
 * Represents a sensenet Release in the Version Info
 */
/**
 * Represents a model for the sensenet's GetVersionInfo custom action's response
 */
/**
 * Returns the current repository's Version Info values and also checks if the installed components has an updated version on https://nuget.org
 */
export const useVersionInfo = () => {
  const [versionInfo, setVersionInfo] = useState();
  const [nugetManifests, setNugetManifests] = useState([]);
  const [hasUpdates, setHasUpdates] = useState(false);
  const repo = useRepository();
  useEffect(() => {
    ;
    (async () => {
      const result = await repo.executeAction({
        idOrPath: ConstantContent.PORTAL_ROOT.Path,
        body: undefined,
        method: 'GET',
        name: 'GetVersionInfo'
      });
      const nugetPromises = result.Components.filter(component => !component.ComponentId.toLocaleLowerCase().includes('demo') && !component.ComponentId.toLocaleLowerCase().includes('aspose')).map(async component => {
        try {
          const response = await fetch(`https://api.nuget.org/v3/registration3-gz-semver2/${component.ComponentId.toLowerCase()}/index.json`);
          if (response.ok) {
            const nugetManifest = await response.json();
            return nugetManifest;
          }
        } catch (error) {
          return {};
        }
      });
      const loadedManifests = (await Promise.all(nugetPromises)).filter(m => m);
      setNugetManifests(loadedManifests);
      let hasOneUpdate = false;
      result.Components = result.Components.map(component => {
        const nugetManifest = loadedManifests.find(m => m['@id'] === `https://api.nuget.org/v3/registration3-gz-semver2/${component.ComponentId.toLocaleLowerCase()}/index.json`);
        const updateAvailable = nugetManifest ? nugetManifest.items[0].upper > component.Version : false;
        if (updateAvailable) {
          hasOneUpdate = true;
        }
        return {
          ...component,
          NugetManifest: nugetManifest,
          IsUpdateAvailable: updateAvailable
        };
      });
      setHasUpdates(hasOneUpdate);
      setVersionInfo(result);
    })();
  }, [repo]);
  return {
    versionInfo,
    nugetManifests,
    hasUpdates
  };
};
//# sourceMappingURL=use-version-info.js.map